import { __awaiter, __generator } from "tslib";
import { inlineMultiSelectKey } from './';
import { Simulate } from 'react-dom/test-utils';
import { noop } from '@wix/answers-lib';
export var createInlineMultiSelectDriver = function (wrapper) {
    var base = wrapper.$("." + inlineMultiSelectKey);
    var mouseDownOnElement = function (e, stopImmediatePropagation) { return __awaiter(void 0, void 0, void 0, function () {
        var rawElem, nativeEvent;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(e.type === 'react')) return [3 /*break*/, 2];
                    return [4 /*yield*/, e.getNative()];
                case 1:
                    rawElem = _a.sent();
                    if (stopImmediatePropagation) {
                        nativeEvent = new Event('mouseDown');
                        nativeEvent.stopImmediatePropagation = noop;
                        Simulate.mouseDown(rawElem, { nativeEvent: nativeEvent });
                    }
                    else {
                        Simulate.mouseDown(rawElem);
                    }
                    return [2 /*return*/, Promise.resolve()];
                case 2: return [2 /*return*/, e.click()];
            }
        });
    }); };
    var focusInput = function () { return __awaiter(void 0, void 0, void 0, function () {
        var elem;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(base.type === 'react')) return [3 /*break*/, 2];
                    return [4 /*yield*/, base.$('.Select-input input').getNative()];
                case 1:
                    elem = _a.sent();
                    Simulate.focus(elem);
                    return [3 /*break*/, 3];
                case 2: return [2 /*return*/, base.$('.Select-input input').click()];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var optionAtIndex = function (index) { return wrapper
        .$$('.Select-option')
        .get(index); };
    return {
        getDisplayedText: function () { return base.text(); },
        openSelection: function () { return base.$('.Select-input input').click(); },
        isMenuOpen: function () { return base.$('.Select-menu-outer').exists(); },
        removeSelectOption: function (idx) { return __awaiter(void 0, void 0, void 0, function () {
            var icon;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, focusInput()];
                    case 1:
                        _a.sent();
                        icon = base.$$('.remove-icon .icon').get(idx);
                        return [2 /*return*/, mouseDownOnElement(icon, true)];
                }
            });
        }); },
        selectAtIndex: function (index) { return __awaiter(void 0, void 0, void 0, function () {
            var option;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, focusInput()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, optionAtIndex(index)];
                    case 2:
                        option = _a.sent();
                        return [2 /*return*/, mouseDownOnElement(option)];
                }
            });
        }); },
        selectOptionsBySelector: function (selector) { return __awaiter(void 0, void 0, void 0, function () {
            var option;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, focusInput()];
                    case 1:
                        _a.sent();
                        option = base.$(selector);
                        return [2 /*return*/, mouseDownOnElement(option)];
                }
            });
        }); },
        getSelectionTitles: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, (base.$$('.Select-option')
                        .map(function (e) { return e.text(); }))];
            });
        }); },
        getSelectedValues: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, base.$$('.inline-multi-value').text()];
                case 1: return [2 /*return*/, (_a.sent()).map(function (val) { return val.trim(); })];
            }
        }); }); },
        valueExists: function () { return base.$('.inline-multi-value').exists(); },
        onHover: function () { return base.$('.unfocused-body').hover(); },
        clickToEdit: function () { return __awaiter(void 0, void 0, void 0, function () {
            var maybeCustomView;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        maybeCustomView = base.$('.custom-view').exists();
                        return [4 /*yield*/, maybeCustomView];
                    case 1:
                        if (_a.sent()) {
                            return [2 /*return*/, base.$('.custom-view').click()];
                        }
                        else {
                            return [2 /*return*/, base.$('.unfocused-body').click()];
                        }
                        return [2 /*return*/];
                }
            });
        }); },
        showingSelect: function () { return base.$('.select-container').exists(); },
        clickClear: function () { return base.$('.clear-button').click(); },
        isClearDisabled: function () { return base.$('.clear-button.disabled').exists(); },
        clickConfirm: function () { return base.$('.confirm-button').click(); },
        clickCancel: function () { return base.$('.cancel-button').click(); },
        searchItems: function (searchTerm) { return base.$('input').enterValue(searchTerm); },
        getSearchInput: function () { return base.$('input').value(); },
        isLoading: function () { return base.$('.tiny-loader').exists(); },
        isDisabled: function () { return base.$('.unfocused-body').hasClass('disabled'); },
        getFocusedPlaceholer: function () { return base.$('.Select-placeholder').text(); },
        base: base,
    };
};
//# sourceMappingURL=driver.js.map